import { makeStyles } from '@mui/styles';
import Table from 'apollo-react/components/Table';
import classNames from 'classnames';
import React, { memo, useMemo } from 'react';

import {
  ENTITY_ALIAS,
  ENTITY_NAME,
  ENTITY_NAME_WIDTH_FIRST_ROW_OFFSET,
  FILTER,
  LINK_SOURCE,
  LINK_TARGET,
  OBJECT_KEY,
} from '../../../constants/report-model-designer.constants';
import ActionCell from '../controls/ActionCell';
import ExpandCell from '../controls/ExpandCell';
import SelectCell from '../controls/SelectCell';
import TextFieldCell from '../controls/TextFieldCell';
import TextViewCell from '../controls/TextViewCell';

const useStyles = makeStyles({
  tableContainer: {
    marginRight: -16,
    '& tr:last-child': {
      height: '0px !important',
    },
    '& thead': {
      display: 'none',
    },
    '& tr': {
      borderBottom: 'none !important',
    },
  },
  selected: {
    '& a, button, p': {
      color: 'white',
    },
    '& td': {
      backgroundColor: '#0768fd !important',
    },
  },
});

const columns = [
  {
    accessor: 'expand',
    customCell: ExpandCell,
    width: 50,
  },
  {
    accessor: ENTITY_NAME,
    customCell: TextViewCell,
  },
  {
    accessor: ENTITY_ALIAS,
    customCell: TextFieldCell,
    width: 400,
  },
  {
    accessor: OBJECT_KEY,
    customCell: SelectCell,
    width: 200,
  },
  {
    accessor: LINK_SOURCE,
    customCell: SelectCell,
    width: 200,
  },
  {
    accessor: LINK_TARGET,
    customCell: SelectCell,
    width: 200,
  },
  {
    accessor: FILTER,
    customCell: TextFieldCell,
    width: 600,
  },
  {
    accessor: 'action',
    customCell: ActionCell,
    align: 'right',
    width: 55,
  },
];

const DetailRow = memo(({ row }) => {
  const {
    views,
    fieldLists,
    handleToggleRow,
    selectRow,
    editRow,
    deleteRow,
    currentExpandedRows,
    selectedViewId,
    level,
    entityNameWidth,
  } = row;

  const classes = useStyles();

  const currentViews = views.filter((v) => v.ParentId === row.Id);

  const rows = useMemo(
    () =>
      currentViews?.map((v) => {
        const parentView = views.find((c) => c.Id === v.ParentId);

        const isExpanded = currentExpandedRows.includes(v.Id) && v.HasChildren;

        return {
          ...v,
          EntityName: v.TranslatedName || v.Name,
          expanded: isExpanded,
          className: classNames(selectedViewId === v.Id && classes.selected),
          level: level + 1,
          entityNameWidth:
            level === 1 ? entityNameWidth + ENTITY_NAME_WIDTH_FIRST_ROW_OFFSET : entityNameWidth,
          views,
          parentEntityName: parentView.Name,
          currentExpandedRows,
          fieldLists,
          selectedViewId,
          handleToggleRow,
          selectRow,
          editRow,
          deleteRow,
        };
      }),
    [
      currentViews,
      views,
      currentExpandedRows,
      selectedViewId,
      classes.selected,
      level,
      entityNameWidth,
      fieldLists,
      handleToggleRow,
      selectRow,
      editRow,
      deleteRow,
    ]
  );

  return (
    <div className={classes.tableContainer}>
      <Table
        columns={columns}
        rowId="Id"
        rows={rows}
        hidePagination
        ExpandableComponent={DetailRow}
      />
    </div>
  );
});

export default DetailRow;
